import { useEffect, useState } from "react";

/**
 * Detect screen size if it's mobile.
 * @returns {boolean}
 *      isPhone: width <= 480,
        isTablet: width <= 1024 && width > 480,
        isMobile: width <= 1024,
 */

export const useIsMobile = () => {
    const actualWidth = document.documentElement.clientWidth || document.body.clientWidth;
    const [width, setWidth] = useState(actualWidth);

    const onWindowLoad = () => {
        const actualWidth = document.documentElement.clientWidth || document.body.clientWidth;
        setWidth(actualWidth);
    };

    useEffect(() => {
        let resizeTimeout: any;
        window.setTimeout(onWindowLoad, 1000);
        const handleWindowResize = () => {
            const windowWidth = document.documentElement.clientWidth || document.body.clientWidth;
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => setWidth(windowWidth), 50);
        };
        window.addEventListener("resize", handleWindowResize);
        return () => window.removeEventListener("resize", handleWindowResize);
    }, []);

    // Return the width so we can use it in our components
    return {
        isPhone: width <= 480,
        isTablet: width <= 1024 && width > 480,
        isMobile: width <= 1024,
        isSmallScreen: width <= 1280,
    };
};
